export default __webpack_public_path__ + "static/media/appgallery.2511b7f7.svg";